import React, { SVGProps } from 'react';

export default ({ ...props }: SVGProps<SVGSVGElement>) => (
  // <svg {...props} viewBox="0 0 38 41" xmlns="http://www.w3.org/2000/svg">
  //   <g fill="none" fillRule="evenodd" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"><path d="m3.623 18.682v20.818h11.528v-12.267h7.359v12.267h11.528v-20.818" transform="translate(0 .627)" /><path d="m37.161 20.638-18.331-13.565-18.33 13.565v-6.199l18.33-13.566 18.331 13.566z" transform="translate(0 .627)" /><path d="m7.184 26.205h4.749v-4.749h-4.749zm18.543 0h4.749v-4.749h-4.749z" /></g>
  // </svg>

  <svg {...props} viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" fill="none">
    <path
      d="M5 19H1L19 1L37 19H33M5 19V33C5 34.0609 5.42143 35.0783 6.17157 35.8284C6.92172 36.5786 7.93913 37 9 37H29C30.0609 37 31.0783 36.5786 31.8284 35.8284C32.5786 35.0783 33 34.0609 33 33V19"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13 37V25C13 23.9391 13.4214 22.9217 14.1716 22.1716C14.9217 21.4214 15.9391 21 17 21H21C22.0609 21 23.0783 21.4214 23.8284 22.1716C24.5786 22.9217 25 23.9391 25 25V37"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
